// *** RESERVATION SERVICE ***

import JsBarcode from 'jsbarcode';
import jsPDF from 'jspdf';
import { getMedDisplayAmount } from './medicationService';

// *** COMBINE RESERVATIONS ***
// Used to combine a reservations array retrieved from the backend
// into a single reservation object.
export const combineReservations = reservations => {
    const reservation = reservations.reduce((acc, res) => {
        if (Object.keys(acc).length === 0) {
            acc = {
                ...res,
                ids: [],
                medications: []
            };
            delete acc.id;
            delete acc.pre_reserved;
        }
        acc.ids.push(res.id);
        res.medications.map(med => {
            const medIndex = acc.medications.findIndex(m => m.vnr === med.vnr);
            if (medIndex === -1) {
                acc.medications.push(med);
            } else {
                const previousAmount =
                    acc.medications[medIndex].amount * med.package_size + acc.medications[medIndex].pills_amount;
                const currentAmount = med.amount * med.package_size + med.pills_amount;
                const newAmount = previousAmount + currentAmount;
                acc.medications[medIndex] = {
                    ...acc.medications[medIndex],
                    amount: Math.floor(newAmount / med.package_size),
                    pills_amount: newAmount % med.package_size
                };
            }
        });
        return acc;
    }, {});
    reservation.medications = _.sortBy(reservation.medications, 'vnr');
    return reservation;
};

// *** CREATE RESERVATION INFO STICKER AND OPEN IT FOR PRINTING ***
// Contains PIN code as barcode, client name and medication info
export const printSticker = res => {
    const height = 33;
    const width = 100;
    const lineHeight = 1.4;
    var doc = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: [width, height],
        compressPdf: false,
        lineHeight,
        putOnlyUsedFonts: true
    });

    doc.setFont('Helvetica', 'normal');
    const fontSize = 8;
    doc.setFontSize(fontSize);

    const img = document.createElement('img');
    JsBarcode(img, res.pin, { format: 'CODE39' });

    const imgScale = 0.65;
    const imgHeight = height * imgScale;
    const imgWidth = imgHeight * (53 / 34);
    doc.addImage(img.src, 'PNG', 0, height - imgHeight, imgWidth, imgHeight);

    // client name
    let topMargin = 3;
    let generalInfo = [];
    const clientStringMaxLength = 20;
    let clientString = res.client;
    // abbreviate client name string that exceeds max length with "..."
    if (clientString.length > clientStringMaxLength) {
        clientString = `${clientString.substring(0, clientStringMaxLength - 1)}...`;
    }
    generalInfo.push(clientString);
    doc.text(2, topMargin, generalInfo);

    // medication info
    const medicationInfoStartX = imgWidth + 2;
    doc.setFillColor('1');
    doc.rect(medicationInfoStartX - 1, 0, width - medicationInfoStartX, height, 'F');
    let medicationInfo = [];
    const medicationInfoMaxRows = 8;
    const medicationInfoMaxRowLength = 58;
    for (const i in res.medications) {
        const med = res.medications[i];
        if (medicationInfo.length < medicationInfoMaxRows) {
            const amountString = getMedDisplayAmount(med.amount, med.pills_amount, false, 'short');
            const medString = `${String.fromCharCode(8226)}\xa0${med.vnr} ${med.name} (${amountString})`;
            let splitString = doc.splitTextToSize(medString, medicationInfoMaxRowLength);
            if (
                medicationInfo.length + splitString.length <= medicationInfoMaxRows &&
                !(
                    medicationInfo.length + splitString.length === medicationInfoMaxRows &&
                    i < res.medications.length - 1
                )
            ) {
                medicationInfo.push(...splitString);
            } else {
                medicationInfo.push(`${String.fromCharCode(8226)}\xa0...`);
            }
        }
    }
    medicationInfo = medicationInfo.map(row => {
        return row[0] === String.fromCharCode(8226) ? row : `  ${row}`;
    });
    doc.text(medicationInfoStartX, topMargin, medicationInfo);

    // FOR TESTING: border
    // doc.setLineDashPattern([2, 2], 0);
    // doc.line(0, 0, width, 0);
    // doc.line(0, height, width, height);
    // doc.line(0, 0, 0, height);
    // doc.line(width, 0, width, height);

    // doc.autoPrint();
    // doc.output('dataurlnewwindow');

    const blob = doc.output('blob');
    const url = URL.createObjectURL(blob);
    const newWindow = window.open(url);

    // Optional: Clean up memory after the window is closed or after a delay
    if (newWindow) {
        // Try the standard load event
        newWindow.onload = () => {
            newWindow.print();
        };

        // Fallback: If onload doesn't fire (common with PDF viewers),
        // trigger print after a short delay.
        setTimeout(() => {
            if (newWindow && !newWindow.closed) {
                newWindow.print();
            }
        }, 500);
    }
};
